<template>
  <a-modal
    :title="title"
    :width="900"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    :cancelText="$t('close')"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="$t('periodDuration')">
          <a-input
            :placeholder="$t('inputPeriodDuration')"
            v-decorator="['periodDuration', validatorRules.periodDuration]"
          />
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="$t('eachPeriodDuration')">
          <a-input :placeholder="$t('inputEachPeriodDuration')" v-decorator="['duration', validatorRules.duration]" />
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="$t('applyAmountWeight')">
          <a-input
            :placeholder="$t('inputApplyAmountWeight')"
            v-decorator="['applyAmountWeight', validatorRules.applyAmountWeight]"
          />
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="$t('serviceFeeWeight')">
          <a-input
            :placeholder="$t('inputServiceFeeWeight')"
            v-decorator="['serviceFeeWeight', validatorRules.serviceFeeWeight]"
          />
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="$t('maxAmount')">
          <a-input :placeholder="$t('inputMaxAmount')" v-decorator="['maxAmount', validatorRules.maxAmount]" />
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="$t('minAmount')">
          <a-input :placeholder="$t('inputMinAmount')" v-decorator="['minAmount', validatorRules.minAmount]" />
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="$t('incrAmount')">
          <a-input :placeholder="$t('inputIncrAmount')" v-decorator="['incrAmount', validatorRules.incrAmount]" />
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="$t('incrQuota')">
          <a-input :placeholder="$t('inputIncrQuota')" v-decorator="['incrQuota', validatorRules.incrQuota]" />
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="$t('allowDiferTime')">
          <dict-radio-group
            v-decorator="['allowDiferTime', validatorRules.allowDiferTime]"
            :dict-code="DICT_CODE.ALLOW_DIFER_TIME"
          />
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="$t('allowPrepay')">
          <a-switch
            :checkedChildren="$t('allow')"
            :unCheckedChildren="$t('notAllow')"
            v-decorator="['allowPrepay', { initialValue: false, valuePropName: 'checked' }]"
          />
        </a-form-item>

        <!-- <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="$t('serviceFeeRate')">
          <a-input
            :placeholder="$t('inputServiceFeeRate')"
            v-decorator="['serviceFeeRate', validatorRules.serviceFeeRate]"
            :disabled="disabled"
          />
        </a-form-item> -->

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="$t('diferFeeRate')">
          <a-input :placeholder="$t('inputDiferFeeRate')" v-decorator="['diferFeeRate', validatorRules.diferFeeRate]" />
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="$t('overdueRate')">
          <a-input :placeholder="$t('inputOverdueRate')" v-decorator="['overdueRate', validatorRules.overdueRate]" />
        </a-form-item>

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="$t('dayInterestRate')">
          <a-input
            :placeholder="$t('inputDayInterestRate')"
            v-decorator="['dayInterestRate', validatorRules.dayInterestRate]"
          />
        </a-form-item>

        <!-- <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="$t('ivaFee')">
          <a-input :placeholder="$t('inputIvaFee')" v-decorator="['ivaFee', validatorRules.ivaFee]" />
        </a-form-item> -->

        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" :label="$t('status')">
          <a-select v-decorator="['status', validatorRules.status]">
            <a-select-option :key="'0'">{{ $t('invalid') }}</a-select-option>
            <a-select-option :key="'1'">{{ $t('valid') }}</a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>
import pick from 'lodash/pick'
import { addProductItem, editProductItem } from '@/webpublicapi/installmentProductManager'
import DictRadioGroup from '../../modules/DictRadioGroup'
// duplicateCheck
export default {
  name: 'DictModal',
  components: {
    DictRadioGroup,
  },
  data() {
    return {
      value: 1,
      title: this.$t('action'),
      allowPrepay: 1,
      productId: '',
      visibleCheck: true,
      requiredCheck: true,
      visible: false,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      confirmLoading: false,
      form: this.$form.createForm(this),
      disabled: false,
    }
  },
  computed: {
    validatorRules() {
      return {
        periodDuration: { rules: [{ required: true, message: this.$t('inputPeriodDuration') }] },
        duration: { rules: [{ required: true, message: this.$t('inputEachPeriodDuration') }] },
        applyAmountWeight: { rules: [{ required: true, message: this.$t('inputApplyAmountWeight') }] },
        serviceFeeWeight: { rules: [{ required: true, message: this.$t('inputServiceFeeWeight') }] },
        maxAmount: {
          rules: [{ required: true, message: this.$t('inputMaxAmount') }],
        },
        minAmount: { rules: [{ required: true, message: this.$t('inputMinAmount') }] },
        incrAmount: { rules: [{ required: true, message: this.$t('inputIncrAmount') }] },
        incrQuota: { rules: [{ required: true, message: this.$t('inputIncrQuota') }] },
        allowDiferTime: { rules: [{ required: true, message: this.$t('inputAllowDiferTime') }] },
        allowPrepay: { rules: [{ required: true, message: this.$t('inputAllowPrepay') }] },
        // serviceFeeRate: { rules: [{ required: this.requiredCheck, message: this.$t('inputServiceFeeRate') }] },
        diferFeeRate: { rules: [{ required: true, message: this.$t('inputDiferFeeRate') }] },
        dayInterestRate: { rules: [{ required: true, message: this.$t('inputDayInterestRate') }] },
        overdueRate: { rules: [{ required: true, message: this.$t('inputOverdueRate') }] },
        ivaFee: { rules: [{ required: false, message: this.$t('inputIvaFee') }] },
        status: { rules: [{ required: true, message: this.$t('selectStatus') }] },
      }
    },
  },
  created() {
    if (process.env.VUE_APP_CONFIG == 'malaysia') {
      this.disabled = true
      this.requiredCheck = false
    }
  },
  methods: {
    add(proId, ssId) {
      this.productId = proId
      this.appSsid = ssId
      this.edit({})
    },
    edit(record) {
      this.form.resetFields()
      this.model = Object.assign({}, record)
      if (record.id) {
        this.allowPrepay = record.allowPrepay
        this.visibleCheck = record.allowPrepay == 1
      }
      this.visible = true
      const data = pick(
        this.model,
        'periodDuration',
        'applyAmountWeight',
        'serviceFeeWeight',
        'duration',
        'maxAmount',
        'minAmount',
        'incrAmount',
        'incrQuota',
        'allowDiferTime',
        'allowPrepay',
        'serviceFeeRate',
        'diferFeeRate',
        'overdueRate',
        'dayInterestRate',
        'status',
        'ivaFee'
      )
      data.allowPrepay = !!data.allowPrepay
      this.$nextTick(() => {
        this.form.setFieldsValue(data)
      })
    },
    onChose(checked) {
      if (checked) {
        this.allowPrepay = 1
        this.visibleCheck = true
      } else {
        this.allowPrepay = 0
        this.visibleCheck = false
      }
    },
    // Confirm
    handleOk() {
      const that = this
      // Trigger form validation
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true
          const formData = Object.assign(this.model, values)
          formData.allowPrepay = +formData.allowPrepay ? 1 : 0
          let obj
          if (!that.model.id) {
            formData.productId = this.productId
            formData.appSsid = this.appSsid
            obj = addProductItem(formData)
          } else {
            obj = editProductItem(formData)
          }
          obj
            .then((res) => {
              if (res.code === 1000) {
                that.$message.success(res.msg)
                that.$emit('ok')
                that.close()
              } else {
                that.$message.warning(res.msg)
              }
            })
            .finally(() => {
              that.confirmLoading = false
            })
        }
      })
    },
    // Close
    handleCancel() {
      this.close()
    },
    close() {
      this.$emit('close')
      this.visible = false
    },
  },
}
</script>
